module.exports = "/_next/static/images/Frame@2x-f1416492117cfe5743995eae1131e0e9.png";